'use strict';

import { getBuyerId } from 'dibs-cookie-jar';
import qs from 'querystring';
import { isAmpReferrer, isEmailReferrer } from './helpers/referrerHelper';
import { shouldShowAd } from './helpers/mobileAdsHelper';
import { sessionStorage } from 'dibs-browser-storage';
import { PAGE_TYPE } from '../../utils/pageConstants';
import isPageType from '../../utils/isPageType';
import { VisitCountModel } from 'dibs-visit-tracking';
import mobileAdsConstants from '../../mobileAds/constants';

const isAllowedPageType = function isAllowedPageType() {
    return !isPageType(PAGE_TYPE.CHECKOUT);
};

const checkPageViewCount = function checkPageViewCount() {
    const visitCountModel = new VisitCountModel();
    return visitCountModel.get('session') >= 2;
};

const shouldSeeInterstitial = function shouldSeeInterstitial() {
    const { emailToken } = qs.parse(location.search);
    let emailReferrer = sessionStorage.getItem('emailReferrer');

    if (isEmailReferrer() || emailToken) {
        sessionStorage.setItem('emailReferrer', true);
        emailReferrer = true;
    }

    return (
        !!getBuyerId(document.cookie) &&
        shouldShowAd() &&
        !emailReferrer &&
        isAllowedPageType() &&
        !isAmpReferrer() &&
        checkPageViewCount()
    );
};

/**
 * Condition:
 * second page view,
 * logged in user,
 * no cookie "dibsMobileInterstitial",
 * not PlaReferrer, not email referrer,
 * not checkout
 * iphone
 *
 * @return {Promise}
 */
const mobileAdsAction = () => dispatch => {
    const { NOTIFICATION_TYPE } = mobileAdsConstants;
    import(/* webpackChunkName: "mobileAds" */
    '../../mobileAds').then(({ initMobileModal }) => {
        initMobileModal();
        dispatch({ type: NOTIFICATION_TYPE });
    });
};

export default {
    name: 'mobileAd',
    rule: () => Promise.resolve(shouldSeeInterstitial()),
    action: mobileAdsAction,
    priority: 150,
};
